import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import ProcessUpdate from '../ProcessUpdate';
import SkidDetails from '../SkidDetails';
import TableList from '../../TableList';
import { fetchOrderInfoByBoxNumber, getBoxScanHistories, getBoxUpdateSummary, saveBoxScanHistory, updateStatusByBoxNumber, validateBagNo } from '../../../../actions/utActions';
import { CircularProgress } from "@material-ui/core";
import { Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField, withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import DetainedPackages from '../DetainedPackages';
import { set } from 'lodash';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import { getCurrentWarehouse, handleCapitalize } from '../../../../utilities/common';
import { getExceptionByState } from '../../../../actions/editOrderActions';
import ExceptionDialog from '../../../EditOrderModal/NextTransition/ExceptionDialog';
import UniDialog from '../../../Common/UniDialog';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

function BatchesBoxUpdate(props) {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');

    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    const skidNosNum = 35;
    let skidNos = [];
    for(let i = 0; i < skidNosNum; i++) { 
        const divide = parseInt(i / 26);
        const mo = i % 26;
        if(divide === 0) {
            skidNos.push(String.fromCharCode(65 + mo));
        } else {
            const left = String.fromCharCode(65 + divide - 1);
            const right = String.fromCharCode(65 + mo);
            skidNos.push(left + '' + right);
        }
    }

    const [state, setState] = useState(199);
    const [checkedBatch, setCheckedBatch] = useState(false);
    const [subBatch, setSubBatch] = useState('');
    const [checkedSkid, setCheckedSkid] = useState(false);
    const [skidNo, setSkidNo] = useState('');
    const [value, setValue] = useState('0');
    const [boxNo, setBoxNo] = useState('');
    const [savedBoxNos, setSavedBoxNos] = useState('');

    const [rowsSummary, setRowsSummary] = useState([]);
    const [boxCheck, setBoxCheck] = useState(3);
    const [detainedTable, setDetainedTable] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [skidHistory, setSkidHistory] = useState([]);
    const [updatedNo, setUpdatedNo] = useState(0);
    const [mixedBags, setMixedBags] = useState([]);
    const [mixedBagsInformOpen, setMixedBagsInformOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [openExceptionDialog, setOpenExceptionDialog] = useState(false);
    const [exceptionList, setExceptionList] = useState([]);

    const [isTransshipment, setIsTransshipment] = useState(0);

    const [totalWeight, setTotalWeight] = useState();
    const [excludeLg, setExcludeLg] = useState(0);


    const exceptionId = useRef(null)

    const BoxNos = useMemo(() => (
        transferBoxNo(boxNo)
      ), [boxNo]);

    const currentWarehouse = useMemo(() => (
        getCurrentWarehouse()
    ), []);
   
    const handleStateChange = (event) => {
        setState(event.target.value);
    };
    const handleTableChange = (event) => {
        setValue(event.target.value);
    };
    const handleBoxTrackingNo = (event) => {
        setBoxNo(event.target.value);
    };
    const handleSubBatch = (event) => {
        setSubBatch(handleCapitalize(event.target.value));
    };
    const handleSkidNo = (event) => {
        setSkidNo(event.target.value);
    };

    function transferBoxNo(boxNos) {
        let newBoxNos = boxNos.split('\n');        
        let newBoxNosCurr = '';
        newBoxNos.forEach((element) => {
            if(element) {
                newBoxNosCurr = newBoxNosCurr.concat(',' + element.trim());
            }
        });
        return newBoxNosCurr.substring(1);
    }
    function checkFormat(boxNo) {
        // var boxNoRegex = /^[-+]?(?:[0-9a-zA-Z]+,)*[0-9a-zA-Z]+(?:[0-9a-zA-Z]+)?$/i;
        var boxNoRegex = /[a-zA-Z0-9\-]/g;
        return boxNoRegex.test(boxNo);
    }

    function resetData(){
        exceptionId.current = null
        setDisabled(false); 
    }
    async function handleBoxUpdate(){
        setLoading(true);
        try{
            const response = await dispatch(updateStatusByBoxNumber(
                BoxNos, 
                state, 
                subBatch, 
                currentWarehouse['id'], 
                exceptionId.current, 
                isTransshipment === 1,
                excludeLg
            ))
            .catch(e => {
                throw e.message || 'update_fail_message';
            });
            setUpdatedNo(response.updated);
            setMixedBags(response.mixedBags);
            await dispatch(showAlertSnackbar({message: response.updated + t('update_success_message'), type: 'success'}))
            if(response.mixedBags?.length > 0 && isTransshipment) {
                setMixedBagsInformOpen(true);
            }
            await dispatch(saveBoxScanHistory(BoxNos, state, skidNo, subBatch, excludeLg)).catch((e) => {
                throw e.message || 'save_fail_message';
            });

            const history = await dispatch(getBoxScanHistories(BoxNos, state, skidNo, excludeLg))
            setSkidHistory(history);

            const orderInfo = await dispatch(fetchOrderInfoByBoxNumber(BoxNos, excludeLg)).catch(e => {
                throw 'fetch_order_fail_message';
            })

            setTotalWeight(orderInfo.total_weight);
            setOrderList(orderInfo.orders);
            setValue('2');
        } catch(e) {
            // dispatch(showAlertSnackbar({message: t(e), type: 'error'}))
        } finally {
            setLoading(false);
            setDisabled(false);
        }
    }

    function handleBoxNos(operation) {
        if(BoxNos) {
            if(checkFormat(BoxNos)) {
                setLoading(true);
                setDisabled(true);      
                if(operation === 1) {
                    setUpdatedNo(0);
                    setMixedBags([]);
                    if(state === 219){
                        setOpenExceptionDialog(true);
                        setLoading(false);
                        return
                    }else{
                        handleBoxUpdate(BoxNos, currentWarehouse['id'])
                    }
                  
                } else if(operation === 2) {
                    // fetch
                    dispatch(fetchOrderInfoByBoxNumber(BoxNos))
                    .then((res) => {
                        setTotalWeight(res.total_weight);
                        setOrderList(res.orders);
                        setValue('2');
                        setLoading(false);
                        setDisabled(false);
                        dispatch(showAlertSnackbar({message: t('fetch_order_success_message'), type: 'success'}))
                    })
                    .catch((err) => {
                        setLoading(false);
                        setDisabled(false);
                        dispatch(showAlertSnackbar({message: t('fetch_order_fail_message'), type: 'error'}))
                    })
                } else if(operation === 3) {
                    // summary
                    dispatch(getBoxUpdateSummary(BoxNos, state))
                    .then((res) => {
                        setRowsSummary(res);
                        setLoading(false);
                        setDisabled(false);
                        dispatch(showAlertSnackbar({message: t('get_summary_success_message'), type: 'success'}))
                    })
                    .catch((err) => {
                        setLoading(false);
                        setDisabled(false);
                        dispatch(showAlertSnackbar({message: t('get_summary_fail_message'), type: 'error'}))
                    })
                }
            } else {
                dispatch(showAlertSnackbar({message: t('format_fail_message'), type: 'error'}))
            }
        } else {
            dispatch(showAlertSnackbar({message: t('empty_fail_message'), type: 'error'}))
        }       
    }
    function handleKeyUp(e) {          
        if(e.keyCode === 13) {
            setOrderList([]);
            setSkidHistory([]);
            // summary
            let newBoxNos = transferBoxNo(boxNo);
            let formerBoxNos = window.localStorage.getItem('savedBoxNos');
            if(formerBoxNos) {
                setSavedBoxNos(formerBoxNos + ',' + newBoxNos);
            } else if(newBoxNos) {
                setSavedBoxNos(newBoxNos);
            }
            // validate
            let newBoxNosArray = boxNo.split('\n');
            let validBoxNosArray = [];
            newBoxNosArray.map((boxNo) => {
                if(boxNo) {
                    validBoxNosArray.push(boxNo);
                }
            })
            let newBoxNo = validBoxNosArray[validBoxNosArray.length - 1];
            dispatch(validateBagNo(newBoxNo, subBatch, state))
            .then(() => {
                // success
                setBoxCheck(1);
                setDetainedTable([]);
                setValue('3');
            })
            .catch((err) => {
                if(!err.code || err.code !== 99003) {
                    // not exist
                    setDetainedTable([]);
                    validBoxNosArray.pop();
                    let validBoxNos = '';
                    validBoxNosArray.map((validBoxNo) => {
                        validBoxNos += validBoxNo + '\n'
                    })
                    setBoxNo(validBoxNos);
                    setBoxCheck(0);
                    setValue('3');
                } else {
                    // 有拦截包裹
                    setDetainedTable(err.additional);
                    validBoxNosArray.pop();
                    let validBoxNos = '';
                    validBoxNosArray.map((validBoxNo) => {
                        validBoxNos += validBoxNo + '\n'
                    })
                    setBoxNo(validBoxNos);
                    setBoxCheck(2);
                    setValue('3');
                }
            })
        }
    }

    // update summary every 30 seconds
    const THIRTY_SECOND = 30000;

    useEffect(() => {
        resetData();
        dispatch(getExceptionByState(219))
        .then((res) => {
            setExceptionList(res)
        })

        if(props.boxUpdate) {
            setIsTransshipment(0);
            setSubBatch('');
            setSkidNo('');
            setState(199);
            setBoxCheck(3);
            setDetainedTable([]);
            setTotalWeight();
            window.localStorage.setItem('savedBoxNos', '');
            setSavedBoxNos('');
            const interval = setInterval(() => {
                if(savedBoxNos) {
                    dispatch(getBoxUpdateSummary(savedBoxNos, state))
                    .then((res) => {
                        setRowsSummary(res);
                    })
                }
            }, THIRTY_SECOND);
            return () => clearInterval(interval);
        }
    }, [props.boxUpdate])
    useEffect(() => {
        if(!checkedBatch) {
            setSubBatch('');
        }
    }, [checkedBatch])
    useEffect(() => {
        setSkidNo('');
    }, [checkedSkid])
    useEffect(() => {
        if(savedBoxNos) {
            window.localStorage.setItem('savedBoxNos', savedBoxNos);
            dispatch(getBoxUpdateSummary(savedBoxNos, state))
            .then((res) => {
                setRowsSummary(res);
            })
        }
    }, [savedBoxNos])

    return (
        <>
            <div 
                style={isMobile ? {
                    display: 'flex',
                    flexDirection: 'column'
                } : {
                    display: 'flex'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Select
                        value={state}
                        onChange={handleStateChange}
                        variant="outlined"
                        style={{ width: 340 }}
                    >
                        <MenuItem value={199}>{t('199')}</MenuItem>
                        <MenuItem value={195}>{t('195')}</MenuItem>
                        <MenuItem value={219}>{t('219')}</MenuItem>
                    </Select>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 20, 
                            marginBottom: 5
                        }}
                    >
                        <Checkbox 
                            id='updatetoolbox-boxupdate-transshipment-checkbox' 
                            color='secondary'
                            checked={isTransshipment}
                            onChange={(e)=>{
                                if(e.target.checked) {
                                    setIsTransshipment(1);
                                } else {
                                    setIsTransshipment(0);
                                }
                            }}
                        />
                        <div>{t('transshipment_confirm')}</div>
                    </div>
                    <div 
                        style={{
                            display: 'flex', 
                            alignItems: 'center',
                            cursor: 'pointer',
                            marginTop: 5, 
                            marginBottom: 5
                        }}
                    >
                        <Checkbox 
                            id='updatetoolbox-boxupdate-islg-checkbox' 
                            color='secondary'
                            checked={excludeLg}
                            onChange={(e)=>{
                                if(e.target.checked) {
                                    setExcludeLg(1);
                                } else {
                                    setExcludeLg(0);
                                }
                            }}
                        />
                        <div>{t('exclude_lg')}</div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 5, 
                            marginBottom: 5
                        }}
                    >
                        <div 
                            onClick={() => setCheckedBatch(!checkedBatch)}
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Checkbox checked={checkedBatch}></Checkbox>
                            <span>{t('link_batch')}</span>
                        </div>
                        <div>
                            <InputTextField
                                variant='outlined'
                                placeholder={t('input_link_batch')}
                                disabled={!checkedBatch}
                                onChange={handleSubBatch}
                                value={subBatch}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 10
                        }}
                    >
                        <div 
                            onClick={() => setCheckedSkid(!checkedSkid)}
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Checkbox checked={checkedSkid}></Checkbox>
                            <span>{t('skid_no')}</span>
                        </div>
                        <InputTextField
                            value={skidNo}
                            select
                            variant='outlined'
                            style={{ marginLeft: 20 }}
                            disabled={!checkedSkid}
                            onChange={handleSkidNo}
                        >
                        {skidNos.map((option) => (
                            <MenuItem key={option} value={option}>
                            {option}
                            </MenuItem>
                        ))}
                        </InputTextField>
                    </div>               
                </div>
                <div
                    style={isMobile ? {
                        display: 'flex',
                        marginTop: 20,
                        flexDirection: 'column'
                    } : {
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 20
                    }}
                >
                    <FixedTextField
                        variant='outlined'
                        placeholder={t('input_box_tracking_no')}
                        onChange={handleBoxTrackingNo}
                        multiline
                        rows={6}
                        value={boxNo}
                        onKeyUp={(e)=>handleKeyUp(e)} 
                    />
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10, marginBottom: 10 }}
                            onClick={() => handleBoxNos(1)}
                            disabled={disabled}
                        >
                            {t('confirm_lot_update')}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10, marginBottom: 10 }}
                            onClick={() => handleBoxNos(2)}
                            disabled={disabled}
                        >
                            {t('obtain_order_list')}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10, marginBottom: 10 }}
                            onClick={() => handleBoxNos(3)}
                            disabled={disabled}
                        >
                            {t('view_update_process')}
                        </Button>
                    </div>
                    {
                        loading &&
                        <div style={{marginLeft:10}}>
                            <CircularProgress color='secondary'/>
                        </div>
                    }
                </div>
            </div>
            <div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <FormControl>
                        <RadioGroup 
                            value={value} 
                            onChange={handleTableChange}
                            row
                        >
                            <FormControlLabel value='0' control={<Radio />} label={t('process_upadte')} />
                            <FormControlLabel value='1' control={<Radio />} label={t('skid_details')} />
                            <FormControlLabel value='2' control={<Radio />} label={t('table_list')} />
                            <FormControlLabel value='3' control={<Radio />} label={t('detained_packages')} />
                        </RadioGroup>
                    </FormControl>
                    {
                        totalWeight &&
                        <div>{t('total_weight')}{totalWeight}</div>
                    }
                </div>
                <div style={{ marginTop: 20 }}>
                    <Snackbar 
                        open={boxCheck===0} 
                        autoHideDuration={6000} 
                        onClose={()=>{setBoxCheck(3)}}
                    >
                        <Alert variant="filled" severity="error" onClose={()=>{setBoxCheck(3)}}>
                            {t('validate_error')}
                        </Alert>
                    </Snackbar>
                    <Snackbar 
                        open={boxCheck===1} 
                        autoHideDuration={6000} 
                        onClose={()=>{setBoxCheck(3)}}
                    >
                        <Alert variant="filled" severity="success" onClose={()=>{setBoxCheck(3)}}>
                            {t('valid')}
                        </Alert>
                    </Snackbar>
                    <Snackbar 
                        open={boxCheck===2} 
                        autoHideDuration={6000} 
                        onClose={()=>{setBoxCheck(3)}}
                    >
                        <Alert variant="filled" severity="warning" onClose={()=>{setBoxCheck(3)}}>
                            {t("detained_packages")}
                        </Alert>
                    </Snackbar>
                </div>
                <div style={{ marginTop: 20 }}>
                    <div hidden={value !== '0'}>
                        <ProcessUpdate rowsSummary={rowsSummary}/>
                    </div>
                    <div hidden={value !== '1'}>
                        <SkidDetails skidHistory={skidHistory}/>
                    </div>
                    <div hidden={value !== '2'}>
                        <TableList orderList={orderList}/>
                    </div>
                    <div hidden={value !== '3'}>
                        <DetainedPackages detainedTable={detainedTable}/>
                    </div>
                </div>
            </div>
            <ExceptionDialog
                exceptions={exceptionList}
                open={openExceptionDialog}
                onClose={()=>{
                    setOpenExceptionDialog(false)
                    resetData()
                }}
                onFinish={(value)=>{
                    exceptionId.current = value
                    handleBoxUpdate()
                }}
            />
            <UniDialog
                title={t('update_res')}
                open={mixedBagsInformOpen}
                autoClose={false}
                onClose={() => {
                    setMixedBags([]);
                    setMixedBagsInformOpen(false);
                }}
                onFinish={() => {
                    setMixedBagsInformOpen(false);
                }}
                finishButtonText={t('common:ok')}
                maxwidth='sm'
                fullWidth={true}
            >
            {
                mixedBags?.length > 0 &&
                <div>
                    <div>
                        {t('updated_success')} {updatedNo || 0}
                    </div>
                    <div style={{
                        marginTop: 20, 
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word',
                        width: '50%'}}
                    >
                        {t('mixed_bags')} {mixedBags?.toString()}
                    </div>
                </div>
            }
            </UniDialog>
        </>
    );
}

export default BatchesBoxUpdate;